import { createContext, useContext } from "react";
import useCustomQuery from "src/hooks/useCustomQuery";
import {
  PlusOneRequestsQuery,
  PlusOneRequestsQueryVariables,
} from "src/types/api.d";

type PlusOneRequestsResult = ReturnType<
  typeof useCustomQuery<PlusOneRequestsQuery, PlusOneRequestsQueryVariables>
>;

export const PlusOneRequestsContext =
  createContext<PlusOneRequestsResult | null>(null);

export function usePlusOneRequests() {
  const result = useContext(PlusOneRequestsContext);
  if (!result)
    throw new Error("Plus-one requests require the dashboard provider");
  return result;
}
